<gig-project-header></gig-project-header>

<div>
    <div class="flex justify-content-end mb-3">
        <button
            type="button"
            pButton
            icon="pi pi-file-pdf"
            label="Export SEO PDF"
            class="p-button-sm"
            [loading]="isExportingSeoPdf"
            (click)="exportSeoComprehensivePdf()"></button>
    </div>
    <p-tabMenu [model]="items" [(activeItem)]="activeItem"/>

    <div *ngIf="activeTab === 'dashboard'" class="p-2">
        <div class="dashboard-overview-container">
            <div *ngIf="dashboardGeneratedAt" class="dashboard-data-context mb-3">
                <span>{{ dashboardMarketLabel }}</span>
                <span>Generated {{ dashboardGeneratedAt | date: 'medium' }}</span>
                <span>{{ dashboardCachedWidgetCount }}/4 datasets cached</span>
            </div>
            <div *ngIf="dashboardErrorWidgets.length" class="dashboard-data-error mb-3" role="alert">
                Some dashboard data is unavailable: {{ dashboardErrorWidgets.join(', ') }}.
            </div>
            <div *ngIf="gaAuthorizationRequired" class="dashboard-data-error mb-3" role="alert">
                Google authorization has expired. Your Analytics configuration is saved.
                <a routerLink="/settings/manage/projects">Reconnect Google</a> to resume importing data.
            </div>
            <section *ngIf="dashboardSummary" class="dashboard-summary mb-3" [attr.data-status]="dashboardSummary.status">
                <div class="dashboard-summary-heading">
                    <div>
                        <span class="dashboard-summary-status">{{ dashboardSummary.status.replace('_', ' ') }}</span>
                        <h2>{{ dashboardSummary.headline }}</h2>
                    </div>
                    <span class="dashboard-summary-confidence">{{ dashboardSummary.confidence }} confidence</span>
                </div>
                <ul *ngIf="dashboardSummary.evidence.length" class="dashboard-summary-evidence">
                    <li *ngFor="let evidence of dashboardSummary.evidence">{{ evidence }}</li>
                </ul>
                <div *ngIf="dashboardSummary.recommendedAction" class="dashboard-summary-action">
                    <strong>Recommended action:</strong> {{ dashboardSummary.recommendedAction }}
                </div>
                <div class="dashboard-summary-links">
                    <a pButton class="p-button-sm p-button-outlined" icon="pi pi-chart-line" label="Open Rank Tracker" routerLink="/seo/rank-tracker"></a>
                    <a pButton class="p-button-sm p-button-outlined" icon="pi pi-link" label="Review Backlinks" routerLink="/seo/backlinks"></a>
                    <a pButton class="p-button-sm" icon="pi pi-lightbulb" label="View Opportunities" routerLink="/dashboard/opportunities"></a>
                </div>
            </section>
            <section class="dashboard-first-party mb-3">
                <div class="dashboard-section-heading">
                    <h2>Google Search performance</h2>
                    <p>First-party Search Console results · Current 28 days compared with the prior 28 days</p>
                </div>
                <gig-gsc-dashboard (stateChange)="onGscStateChange($event)"></gig-gsc-dashboard>
            </section>
            <div class="grid">
                <div class="col-6 md:col-3">
                    <gig-overview-box [title]="'Domain Rank'"
                        [overviewText]="dashboardWidgets['backlinksSummary']?.status === 'ready' ? (backlinksSummaryData?.rank ?? 0) : '—'"
                        [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" type="string" toolTipPath="dashboard.authority">
                    </gig-overview-box>
                </div>
                <div class="col-6 md:col-3">
                    <gig-overview-box [title]="'Estimated Organic Traffic'"
                        [overviewText]="dashboardWidgets['domainRank']?.status === 'ready' ? ((rankedKeywordsData?.metrics?.organic?.etv ?? 0) | truncateNumber: 0: 'number') : '—'" [showBadge]="false"
                        [badgeClass]="'pi pi-arrow-down'" type="string" toolTipPath="dashboard.organicSearchTraffic">
                    </gig-overview-box>
                </div>
                <div class="col-6 md:col-3">
                    <gig-overview-box [title]="'Estimated Paid Traffic'"
                        [overviewText]="dashboardWidgets['domainRank']?.status === 'ready' ? ((rankedKeywordsData?.metrics?.paid?.etv ?? 0) | truncateNumber: 0: 'number') : '—'" [showBadge]="false"
                        [badgeClass]="'pi pi-arrow-down'" type="string" toolTipPath="dashboard.paidSearchTraffic">
                    </gig-overview-box>
                </div>
                <div class="col-6 md:col-3">
                    <gig-overview-box
                    [title]="'Backlinks'"
                    [overviewText]="dashboardWidgets['backlinksSummary']?.status === 'ready' ? ((backlinksSummaryData?.backlinks ?? 0) | number: '1.0-2') : '—'"
                    [showBadge]="false"
                    [badgeClass]="'pi pi-arrow-down'"
                    type="string"
                    toolTipPath="dashboard.backlinks">
                    </gig-overview-box>
                </div>
                <ng-container *ngIf="gaSummaryTableData?.length">
                    <div class="col-6 md:col-3">
                        <gig-overview-box
                            [title]="'Total Active Users'"
                            [overviewText]="gaSummaryDataActiveUser | number: '1.0-2'"
                            [showBadge]="false"
                            [badgeClass]="'pi pi-arrow-down'"
                            type="number"
                            toolTipPath="dashboard.totalActiveUsers">
                        </gig-overview-box>
                    </div>
                    <div class="col-6 md:col-3">
                        <gig-overview-box
                            [title]="'Total Sessions'"
                            [overviewText]="gaSummaryDataSessions | number: '1.0-2'"
                            [showBadge]="false"
                            [badgeClass]="'pi pi-arrow-down'"
                            type="number"
                            toolTipPath="dashboard.totalSessions">
                        </gig-overview-box>
                    </div>
                    <div class="col-6 md:col-3">
                        <gig-overview-box
                            [title]="'Total New Users'"
                            [overviewText]="gaSummaryDataNewUser | number: '1.0-2'"
                            [showBadge]="false"
                            [badgeClass]="'pi pi-arrow-down'"
                            type="number"
                            toolTipPath="dashboard.totalNewUsers">
                        </gig-overview-box>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="card">
            <div class="keyword-traffic-toggle-container">
                <p-selectButton class="keyword-traffic-toggle" [options]="metricTypes" [(ngModel)]="metricType"
                optionLabel="name" dataKey="value" (onChange)="onkeywordTrafficChange($event)"></p-selectButton>
            </div>
            <div class="keywor-traffic-charts">
                <div class="grid">
                    <div class="col-12 lg:col-6">
                        <gig-chart-wrapper [chartData]="trafficData?.items" [title]="metricType?.value === 'paid' ? 'Paid Keywords' : 'Organic Keywords'" #keywordChartWrapper
                        type="paidKeywords" (chartWrapperEvent)="onChartWrapperEvent($event)" toolTipPath="dashboard.organicKeywords">
                            <gig-position-distribution-chart  *ngIf="metricType?.value === 'organic'" #keywordsChart
                                [chartData]="trafficData?.items" [chartColors]="chartColors1"
                                chartType="line" [chartPositionNames]="chartPositionNames"
                                [parameters]="['metrics', 'organic']"
                                type="position_distribution">
                            </gig-position-distribution-chart>
                            <gig-position-distribution-chart *ngIf="metricType?.value === 'paid'" #keywordsChart
                                [chartData]="trafficData?.items" [chartColors]="chartColors1"
                                chartType="line" [chartPositionNames]="chartPositionNames"
                                [parameters]="['metrics', 'paid']"
                                type="position_distribution"></gig-position-distribution-chart>
                            </gig-chart-wrapper>
                    </div>
                    <div class="col-12 lg:col-6">
                        <gig-chart-wrapper [chartData]="trafficData?.items" [title]="metricType?.value === 'paid' ? 'Paid' : 'Organic'" #trafficChartWrapper
                        type="organicKeywords" (chartWrapperEvent)="onChartWrapperEvent($event)" toolTipPath="dashboard.organic">
                            <gig-position-distribution-chart *ngIf="metricType?.value === 'organic'" #trafficChart
                                [chartData]="trafficData?.items" [chartColors]="chartColors1"
                                chartType="line" [chartPositionNames]="chartPositionNames"
                                [parameters]="['metrics', 'organic']"
                                type="estimated_traffic">
                            </gig-position-distribution-chart>

                            <gig-position-distribution-chart *ngIf="metricType?.value === 'paid'" #trafficChart
                                [chartData]="trafficData?.items" [chartColors]="chartColors1"
                                chartType="line" [chartPositionNames]="chartPositionNames"
                                [parameters]="['metrics', 'paid']"
                                type="estimated_traffic">
                            </gig-position-distribution-chart>
                        </gig-chart-wrapper>
                    </div>
                </div>
            </div>
        </div>
        <details class="dashboard-evidence">
            <summary>Detailed SEO and backlink evidence</summary>
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-6 xl:col-3">
                <div class="card">
                        <gig-position-distribution-chart #historicalVisChart [chartData]="trafficData?.items"
                            chartType="bar" type="historical_visibility_changes" height="15rem" *ngIf="trafficData" [chartColors]="chartColors1" toolTipPath="rankTracker.historicVisibility">
                        </gig-position-distribution-chart>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 xl:col-3">
                <div class="card">
                        <gig-position-distribution-chart #historicalRankAverage [chartData]="trafficData?.items"
                            chartType="bar" type="historical_rank_average" height="15rem" *ngIf="trafficData" [chartColors]="chartColors1" toolTipPath="rankTracker.historicAvgRank">
                        </gig-position-distribution-chart>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 xl:col-3">
                <div class="card">
                        <gig-position-distribution-chart #newKeywordsOvertime [chartData]="trafficData?.items"
                            chartType="bar" type="new_keywords_over_time" height="15rem" *ngIf="trafficData" [chartColors]="chartColors1" toolTipPath="rankTracker.newKeywordsOverTime">
                        </gig-position-distribution-chart>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 xl:col-3">
                <div class="card">
                        <gig-position-distribution-chart #lostKeywordsOvertime [chartData]="trafficData?.items"
                            chartType="bar" type="lost_keywords_over_time" height="15rem" *ngIf="trafficData" [chartColors]="chartColors1" toolTipPath="rankTracker.lostKeywordsOverTime">
                        </gig-position-distribution-chart>
                </div>
            </div>
        </div>

        <div class="keywor-traffic-charts">
            <div class="grid">
                <div class="col-12 lg:col-9 p-0">
                    <div class="grid">
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="Referring Domain Over Time" toolTipPath="dashboard.referringDomainOverTime">
                                    <gig-position-distribution-chart [chartData]="backlinksHistoryData?.items" *ngIf="backlinksHistoryData"
                                        [chartColors]="chartColors1" chartType="line"
                                        [chartPositionNames]="{'referringMainDomains': 'Referring Main Domains', 'referringDomains': 'Referring Domains'}"
                                        type="default">
                                    </gig-position-distribution-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="Referring Pages & Backlinks Over Time" toolTipPath="dashboard.referringPagesBacklinksOverTime">
                                    <gig-position-distribution-chart [chartData]="backlinksHistoryData?.items" *ngIf="backlinksHistoryData"
                                        [chartColors]="chartColors1" chartType="line"
                                        [chartPositionNames]="{'backlinks': 'Backlinks', 'referringPages': 'Referring Pages'}"
                                        type="default">
                                    </gig-position-distribution-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="Domain Rank Over Time" toolTipPath="dashboard.domainRank">
                                    <gig-position-distribution-chart [chartData]="backlinksHistoryData?.items" *ngIf="backlinksHistoryData"
                                        [chartColors]="chartColors1" chartType="line" [chartPositionNames]="{'rank': 'Rank'}"
                                        type="default">
                                    </gig-position-distribution-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="New vs Lost Referring Domains" toolTipPath="dashboard.newlostDomains">
                                    <gig-positive-negative-chart [data]="referringDomainsPositiveNegativeChartData" [options]="referringDomainsPositiveNegativeChartOptions"></gig-positive-negative-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="New vs Lost Backlinks" toolTipPath="dashboard.newLostBacklinks">
                                        <gig-positive-negative-chart
                                        [data]="backLinksPositiveNegativeChartData"
                                        [options]="backLinksPositiveNegativeChartOptions"
                                        ></gig-positive-negative-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <div class="card">
                                <gig-chart-wrapper [chartData]="backlinksHistoryData?.items" title="Broken Backlinks"
                                toolTipPath="dashboard.brokenBacklinks">
                                    <gig-position-distribution-chart [chartData]="backlinksHistoryData?.items" *ngIf="backlinksHistoryData"
                                        [chartColors]="chartColors2" chartType="bar"
                                        [chartPositionNames]="{'brokenBacklinks': 'Broken Backlinks'}"
                                        type="default">
                                    </gig-position-distribution-chart>
                                </gig-chart-wrapper>
                            </div>
                        </div>
                        <div class="col-12 lg:col-12" *ngIf="gaSummaryTableData?.length">
                            <gig-ga-summary-table
                            [title]="'Traffic Summary By Country'"
                            [tableData]="gaSummaryTableData"
                            [totals]="gaSummaryTotalArray"
                            toolTipPath="dashboard.trafficSummaryByCountry"
                            [showUpDwnImg]="false">
                            </gig-ga-summary-table>
                        </div>
                    </div>
                </div>
                <div class="col-12 lg:col-3 p-0">
                    <div class="col pr-0 pl-1">
                        <gig-website-info type="web-info" [data]="backlinksSummaryData"></gig-website-info>
                    </div>
                    <div class="col pr-0 pl-1">
                        <gig-dynamic-info-list [data]="backlinksSummaryData?.referringLinksSemanticLocations" [cols]="['Location', '']"
                        [title]="'Backlinks semantic locations'" toolTipPath="dashboard.backlinksSemanticLocation"></gig-dynamic-info-list>
                    </div>
                    <div class="col pr-0 pl-1">
                        <gig-website-info type="referring-domain" [data]="backlinksSummaryData"></gig-website-info>
                    </div>
                    <div class="col pr-0 pl-1">
                        <gig-dynamic-info-list [data]="backlinksSummaryData?.referringLinksPlatformTypes" [cols]="['Platform Type', '']"
                        [title]="'Referring platform types'" toolTipPath="dashboard.platformTypes"></gig-dynamic-info-list>
                    </div>
                    <div class="col pr-0 pl-1">
                        <gig-dynamic-info-list [data]="backlinksSummaryData?.referringLinksTld" [cols]="['Location', 'Domains (1000)']"
                        [title]="'Referring TLDs distribution'" toolTipPath="dashboard.referringTLDsDistribution"></gig-dynamic-info-list>
                    </div>
                    <div class="col pr-0 pl-1">
                        <gig-dynamic-info-list [data]="backlinksSummaryData?.referringLinksAttributes" [cols]="['Attribute', 'Backlinks']" [title]="'Referring links attributes'"></gig-dynamic-info-list>
                    </div>
                </div>
            </div>
        </div>
        </details>
    </div>

    <div *ngIf="activeTab == 'ga-kpi'" class="p-2">
        <div>
            <gig-google-analytics-traffic-report></gig-google-analytics-traffic-report>
            <!-- <gig-google-analytics-kpi></gig-google-analytics-kpi> -->
        </div>
    </div>

    <!-- <div *ngIf="activeTab === 'gsc-dashboard'" class="p-2">
        <gig-gsc-dashboard></gig-gsc-dashboard>
    </div>-->

    <div *ngIf="activeTab === 'opportunities'" class="p-2">
        <gig-opportunities-workspace></gig-opportunities-workspace>
    </div> 

</div>
